const initialState = false;

export default (state = initialState, action) => {
	switch (action.type) {
		case "PERSISTED":
			return true;

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/persist.js